<template lang="pug">
    .container(ref='container')
        .animated-scroll(
            ref='animatedScroll'
            :class='theme'
            )
            .ab.bomb(v-if='name==="bomb"' ref='bomb')
                svg(width='100%' height='100%' viewBox='0 0 1280 720' preserveAspectRatio='xMidYMid meet')
                    path(d='M691.49 268.53C707.79 238.61 733.53 219.44 759.04 206.85V190C746.3 194.92 714.4 214.16 703.27 225.72C691.23 238.24 683 251.75 678.52 260.16L691.49 268.53Z' fill='black')
                    g.bomb__wick
                        rect(width='200' height='200' fill='var(--color-first)' x='850' y='80' transform='rotate(-59 817 240)')
                        path(d='M817.358 240.003L786.364 216.41L775.282 257L769.812 216.651L739.251 232.059L749.758 199.654L712 196.139L750.909 183.62L727.88 153.238L764.247 165.997L760.745 123L781.519 162.627L807.282 126.082L799.078 163.879L833.91 162.675L808.674 187.328L846 204.999L803.54 203.313L817.358 240.003Z' fill='black')
                    path(d='M649.71 241.55L633.26 266.99C625.62 265.52 617.77 264.71 609.73 264.71C541.4 264.75 486 320.15 486 388.51C486 456.87 541.4 512.28 609.76 512.28C678.12 512.28 733.52 456.88 733.52 388.51C733.52 358.81 723.06 331.57 705.62 310.24L720.49 287.26L649.71 241.55Z' fill='black')
                    g.bomb__light
                        path(d='M1088.14 154.507L841.582 162.984L949.259 -330.388L667.395 66.5307L440.469 -364L480.756 125.864L188.93 24.296L383.041 278.873L-92.494 430.421L413.366 477.332L343.34 692.013L532.03 597.606L599.273 1092L730.097 614.851L995.846 815.794L878.793 507.73L1372.49 527.313L922.45 314.97L1088.14 154.507Z' fill='black')
                    g.bomb__light
                        path(d='M740.76 495.352L659.346 433.375L630.233 540L615.865 434.008L535.585 474.482L563.185 389.36L464 380.126L566.21 347.241L505.716 267.431L601.246 300.949L592.046 188L646.617 292.095L714.294 196.095L692.743 295.383L784.241 292.221L717.949 356.98L816 403.399L704.464 398.972L740.76 495.352Z' fill='#2E6846')
                    g.bomb__light
                        path(d='M610.452 350.187L626.709 350.746L619.609 318.216L638.194 344.387L653.156 316L650.5 348.299L669.741 341.602L656.942 358.387L688.296 368.38L654.943 371.473L659.56 385.627L647.119 379.403L642.685 412L634.059 380.54L616.537 393.789L624.255 373.477L591.703 374.768L621.377 360.767L610.452 350.187Z' fill='black')
            .ab.ab_train.train(v-else-if='name==="train"' ref='train')
                img.train__rail(src='@/assets/img/articles/part-1/article-2/big-animations/rail.svg')
                .train__train
                    img(src='@/assets/img/articles/part-1/article-2/big-animations/train.svg')
                    
            .ab.ab_hourglass.hourglass(v-else-if='name==="hourglass"' ref='hourglass')
                svg(width='100%' height='100%' viewBox='0 0 1280 728' preserveAspectRatio='xMidYMid meet')
                    g.hourglass__wrapper
                        g.hourglass__sand-top
                            rect(width='300' height='400' x='492' y='447' fill='black')
                        g(transform='rotate(180 640 364)')
                            path.hourglass__mask(d='M0 -346V1122H1280V-346H0ZM737.97 243.34L644 362.24V589.5H635.83V362.24L543 243.34V137H737.97V243.34Z' fill='var(--color-first)')
                        g.hourglass__sand-bottom
                            rect(width='300' height='170' x='492' y='117' fill='black')
                        path(d='M0 -416V1174H1280V-416H0ZM737.97 243.34L644 362.24V364.26L737.97 483.16V589.5H644H635.83H543V483.16L635.83 364.26V362.24L543 243.34V137H635.83H644H737.97V243.34Z' fill='var(--color-first)')
                        g.hourglass__case
                            path(d='M524.17 465.21C516.6 472.04 512.47 480.59 512.47 489.41V594.2H533.24V491.71C533.24 483.08 536.7 474.72 543.04 468.04L623.96 366.68V360.76L543.04 263.03C536.7 256.35 533.24 247.99 533.24 239.36V137.53H746.88V239.35C746.88 247.98 743.42 256.34 737.08 263.02L657.78 360.75V366.67L737.08 468.03C743.42 474.71 746.88 483.07 746.88 491.7V594.2H767.65V489.41C767.65 480.59 763.52 472.04 755.95 465.21L668.24 366.8V360.75L755.95 262.34C763.52 255.51 767.65 246.96 767.65 238.14V127.31H512.47V238.14C512.47 246.96 516.6 255.51 524.17 262.34L614.08 360.75V366.8L524.17 465.21Z' fill='black')
                            path(d='M787.11 617.05H493V646.56H787.11V617.05Z' fill='black')
                            path(d='M777.89 590.03H502.22V610.46H777.89V590.03Z' fill='black')
                            path(d='M787.11 81H493V110.51H787.11V81Z' fill='black')
                            path(d='M777.89 117.1H502.22V137.53H777.89V117.1Z' fill='black')
            .ab.ab_theater.theater(v-else-if='name==="theater"' ref='theater')
                .theater__col(v-for='item in 7' )
            .ab.ab_cards.cards(v-else-if='name==="cards"' ref='cards')
                .card-wrp
                    .card.card-1
                        img(src='@/assets/img/articles/part-1/article-6/big-animations/card-1.svg')
                .card-wrp
                    .card.card-2
                        img(src='@/assets/img/articles/part-1/article-6/big-animations/card-2.svg')
                .card-wrp
                    .card.card-3
                        img(src='@/assets/img/articles/part-1/article-6/big-animations/card-3.svg')
            .ab.ab_forest.forest(v-else-if='name==="forest"' ref='forest')
                svg(width='100%' height='100%' viewBox='0 0 1280 401' preserveAspectRatio='xMidYMid meet')
                    g.forest__spruces
                        g.forest__spruce
                            path(d='M237.54 319.23L153.69 233.1H207L123.14 146.96H176.45L54.27 0L-67.91 146.96H-14.6L-98.45 233.1H-45.14L-129 319.23H31.92L28.57 401H81.19L77.84 319.23H237.54Z' fill='#2E6846')
                        g.forest__spruce
                            path(d='M457.52 335.75L390.6 267.01H433.15L366.23 198.28H408.77L311.27 81L213.77 198.28H256.31L189.4 267.01H231.94L165.02 335.75H293.44L290.77 401H332.75L330.08 335.75H457.52Z' fill='#2E6846')
                        g.forest__spruce
                            path(d='M638.379 347.44L583.449 291.02H618.369L563.439 234.59H598.359L518.329 138.33L438.289 234.59H473.219L418.289 291.02H453.209L398.279 347.44H503.689L501.499 401H535.959L533.769 347.44H638.379Z' fill='#2E6846')
                        g.forest__spruce
                            path(d='M878.639 347.44L823.709 291.02H858.629L803.699 234.59H838.619L758.589 138.33L678.549 234.59H713.479L658.549 291.02H693.469L638.539 347.44H743.949L741.759 401H776.219L774.029 347.44H878.639Z' fill='#2E6846')
                        g.forest__spruce
                            path(d='M1112.92 335.75L1046.01 267.01H1088.55L1021.63 198.28H1064.17L966.67 81L869.17 198.28H911.71L844.8 267.01H887.34L820.42 335.75H948.84L946.17 401H988.15L985.48 335.75H1112.92Z' fill='#2E6846')
                        g.forest__spruce
                            path(d='M1409.54 319.23L1325.69 233.1H1379L1295.14 146.96H1348.45L1226.27 0L1104.09 146.96H1157.4L1073.55 233.1H1126.86L1043 319.23H1203.92L1200.57 401H1253.19L1249.84 319.23H1409.54Z' fill='#2E6846')
            .default(v-else ref='default')
                span Анимация на весь экран
</template>
<script>
import {lib} from '../../assets/js/animation/animation-blocks';
import {mixinAnimation} from '../mixins/animatedScreen';

export default {
    mixins: [mixinAnimation],
    data() {
        return {
            lib,
            isControlScroll: true
        };
    },
    props: {
        name: {
            type: String,
            default: 'default'
        },
        theme: String
    },
    methods: {
        createAnimation() {
            this.scrollHandler();
            this.timeline = this.lib[this.name]
                ? this.lib[this.name].createTimeline(this.$refs[this.name])
                : this.lib['default'].createTimeline(this.$refs['default']);
            this.timeline.progress(0.0001);
            this.timeline.pause();
            this.lib[this.name] ? this.createScroll(...this.lib[this.name].fromTo) : this.createScroll(...this.lib['default'].fromTo);
        }
    }
};
</script>
<style lang="scss" scoped>
.container {
    height: 190vh;
    position: relative;
    overflow: hidden;
}

.animated-scroll {
    position: absolute;
    top: 0;
    left: 0;
    height: auto;
    width: 100%;
    height: 100vh;
    display: flex;
    &.black {
        background-color: var(--color-black);
    }
    &.color {
        background-color: var(--theme);
    }
    .default {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    img {
        display: block;
        width: 100%;
    }
}

.bomb {
    height: 100%;
    width: 100%;
}
.train {
    position: absolute;
    width: 80%;
    height: fit-content;
    bottom: -30%;
    left: 50%;
    transform: translateX(-50%);
    @media screen and (--viewport-tablet) {
        bottom: auto;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -30%);
        width: 180vw;
    }
    @media screen and (--viewport-mobile-lp) {
        width: 70%;
    }
    &__rail {
        display: block;
        width: 100%;
        height: auto;
    }
    &__train {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        img {
            display: block;
            width: 100%;
            height: auto;
        }
    }
}
.hourglass {
    height: 100%;
    width: 100%;
}
.theater {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    &__col {
        background-color: var(--theme);
        width: calc(100vw / 9);
        height: 100%;
    }
}
.card {
    &-wrp {
        width: calc(10vh + 15vw);
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
.forest {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
}
</style>
